import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ILocationType } from '@user/store/locationTypes/typings'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'

type Props = {
  locationTypes: ILocationType[]
  name: string
  label: string
  show: boolean
  required?: boolean
  disabled?: boolean
  density?: DensityType
}

export default function LocationTypeSelect(props: Props) {
  const { name, show, disabled, required, locationTypes, ...rest } = props

  const { initialOption, isSubmitting, helperText, showError, ...restUseData } =
    useData({ required, name, locationTypes })

  const { handelChange, handelFocus, handelBlur } = useHandlers({ name })

  return show ? (
    <Box>
      <Select<ILocationType>
        {...rest}
        {...restUseData}
        disabled={isSubmitting || disabled}
        required={required}
        error={showError}
        onChange={handelChange}
        value={initialOption}
        optionMode={'normal'}
        onFocus={handelFocus}
        onBlur={handelBlur}
        testId={`location-type-select`}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
